import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';

export const getEminitiesList = async (currentPage) => {
  let responseObj = await dataAccess.get(`${API_CONSTANTS.EMINITIES}/list`);
  return responseObj;
};
